export default __webpack_public_path__ + "static/media/Tamil_Nadu_Hover.124b4a38.svg";